module.exports = "/static/assets/8bdce73195bf475057ff606ab3f6fffb.png";